import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import "./story-tags.m.css";

function Tag(props) {
  const style = {
    "background-color": props.color
  };
  return (
    <Link href={"/topic/" + props.tag.name} className="story-tag" style={style}>
      {props.tag.name}
    </Link>
  );
}
Tag.propTypes = {
  tag: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string
  }),
  color: PropTypes.string
};

function StoryTags({ tags = [], color = "2f2bad" }) {
  return (
    <ul styleName="tag-wrapper">
      {tags.map((tag, index) => (
        <li styleName="tag-element" key={index}>
          <Tag key={index} tag={tag} color={color} />
        </li>
      ))}
    </ul>
  );
}

export { StoryTags };

StoryTags.propTypes = {
  tags: PropTypes.array,
  color: PropTypes.string
};
